import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as BoostsActions from './boosts.actions';
import { switchMap, catchError, of, map, mergeMap } from 'rxjs';
import { BoostService } from '../../../services';
import { BoostOfferStatus } from '../models';
import { BoostOfferResponse } from '@woolworthsnz/trader-api/cjs/model/boostOfferResponse';

@Injectable()
export class BoostsEffects {
	public loadBoostOffers$ = createEffect(() =>
		this.actions$.pipe(
			ofType(BoostsActions.loadBoostOffers),
			switchMap(() =>
				this.boostService.fetchBoostOffers().pipe(
					map((offers) => BoostsActions.loadBoostOffersComplete({ offers: this.sortOffers(offers ?? []) })),
					catchError(() => of(BoostsActions.loadBoostOffersFailed()))
				)
			)
		)
	);

	public loadBoostOffer$ = createEffect(() =>
		this.actions$.pipe(
			ofType(BoostsActions.loadBoostOffer),
			mergeMap((action) =>
				this.boostService.fetchBoostOffer(action.id).pipe(
					map((offer) => BoostsActions.loadBoostOfferComplete({ offer })),
					catchError(() => of(BoostsActions.loadBoostOfferFailed()))
				)
			)
		)
	);

	public activateBoostOffer$ = createEffect(() =>
		this.actions$.pipe(
			ofType(BoostsActions.activateBoostOffer),
			mergeMap((action) =>
				this.boostService.activateBoostOffer(action.id).pipe(
					map(() => BoostsActions.activateBoostOfferComplete({ activatedOfferIdList: [action.id] })),
					catchError(() => of(BoostsActions.activateBoostOfferFailed({ id: action.id })))
				)
			)
		)
	);

	public activateAllBoostOffers$ = createEffect(() =>
		this.actions$.pipe(
			ofType(BoostsActions.activateAllBoostOffers),
			switchMap(() =>
				this.boostService.activateAllBoostOffers().pipe(
					map(() => BoostsActions.activateAllBoostOffersComplete()),
					catchError(() => of(BoostsActions.activateAllBoostOffersFailed()))
				)
			)
		)
	);

	constructor(
		private actions$: Actions,
		private boostService: BoostService
	) {}

	// TODO: CLSE-2733 - Remove FE sorting when sorting is taken care of in EDR services
	private sortOffers(offers: BoostOfferResponse[]): BoostOfferResponse[] {
		return offers.sort(this.sortCompletedOffersLast);
	}

	private sortCompletedOffersLast(a: BoostOfferResponse, b: BoostOfferResponse): number {
		if (a.offerStatus === BoostOfferStatus.Redeemed && b.offerStatus !== BoostOfferStatus.Redeemed) {
			return 1; // move offer towards the end if it is redeemed
		} else if (a.offerStatus !== BoostOfferStatus.Redeemed && b.offerStatus === BoostOfferStatus.Redeemed) {
			return -1; // keep offer at the beginning if not redeemed
		} else {
			return 0; // keep order the same in all other cases
		}
	}
}
